import * as React from 'react';

export default (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || 24}
      height={props.height || 24}
      viewBox="0 0 24 24"
      fill="none"
    >
      <rect width="6" height="8" x="4" y="4" stroke={props.color} strokeWidth="2" rx="1" />
      <rect width="6" height="4" x="4" y="16" stroke={props.color} strokeWidth="2" rx="1" />
      <rect width="6" height="4" x="14" y="4" stroke={props.color} strokeWidth="2" rx="1" />
      <rect width="6" height="8" x="14" y="12" stroke={props.color} strokeWidth="2" rx="1" />
    </svg>
  );
};
